// Constantes que o CRM e a Listagem compartilham. Antes viviam duplicadas
// dentro de cada página; com a listagem virando componente global, passaram a
// precisar de um lugar só — senão a cor de uma etapa mudava num canto e não no
// outro. (Relatorios.js ainda tem cópias próprias; migrar quando for mexer lá.)

export const ETAPAS = [
  { key: 'lead',           label: 'Lead',           cor: '#6b7280', bg: '#f9fafb' },
  { key: '1contato',       label: '1º Contato',     cor: '#3b82f6', bg: '#eff6ff' },
  { key: 'viabilidade',    label: 'Viabilidade',    cor: '#f59e0b', bg: '#fffbeb' },
  { key: 'negociacao',     label: 'Negociação',     cor: '#8b5cf6', bg: '#f5f3ff' },
  { key: 'ganho',          label: 'Ganho',          cor: '#16a34a', bg: '#f0fdf4' },
  { key: 'perdido',        label: 'Perdido',        cor: '#dc2626', bg: '#fef2f2' },
  { key: 'sem-interacao',  label: 'Sem interação',  cor: '#9ca3af', bg: '#f3f4f6' },
];

export const ORIGENS_OP = ['Parceiros', 'SDR', 'Ativo', 'Cliente', 'Network', 'Rede Social', 'Anúncios', 'Site'];

export const COR_ORIGEM = {
  Parceiros: '#7c3aed', SDR: '#0369a1', Ativo: '#b45309', Cliente: '#16a34a',
  Network: '#0a1628', 'Rede Social': '#db2777', 'Anúncios': '#d97706', Site: '#0891b2',
};

// A listagem abre só com o que está em andamento. Ganho, perdido e sem
// interação entulham a tabela e quase nunca são o que se procura ali — mas
// continuam a um clique nos chips de etapa dentro do modal.
export const ETAPAS_FORA_DA_LISTA = ['ganho', 'perdido', 'sem-interacao'];
export const etapasPadraoDaLista = () =>
  ETAPAS.filter(e => !ETAPAS_FORA_DA_LISTA.includes(e.key)).map(e => e.key);
